import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LandingHero from "./LandingPage/LandingHeroPage";
import LandingService from "./LandingPage/LandingService";
import { LandingFooter } from "./LandingPage/LandingFooter";

const LandingScreen = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <LandingHero />
      <LandingService />
      <LandingFooter />
    </>
  );
};

export default LandingScreen;
